module.exports = __webpack_public_path__ + "static/media/potrait-mobile.0d3803d8.jpg";